import { useState } from "react";
import axios from "axios";
import { ROOT_URL, getAuthHeaders } from '../actions/constants';

const usePutRequest = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = async (body) => {
    setLoading(true);
    try {
      const response = await axios.put(`${ROOT_URL}/${url}`, body, getAuthHeaders());
      setData(response.data);
      setError(null);
    } catch (err) {
      setData(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, sendRequest };
};

export default usePutRequest;